var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 158 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.1 13.913 66.68 40h-8.697L48.56 13.913h7.247l6.523 20.522 6.523-20.522zM7.248 34.435h14.495V40H0V13.913h7.248zM110.89 34.435h14.495V40h-21.743V13.913h7.248zM31.89 34.435v-5.061h11.596v-4.87H31.89v-5.026h13.77v-5.565H24.643V40h21.743v-5.565zM86.248 34.435v-5.061h11.596v-4.87H86.248v-5.026h13.77v-5.565H79V40h21.743v-5.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA5B0C",
    d: "M151.477 6.957h-11.596v20.521h5.798V20.87h5.798c3.606 0 6.523-2.8 6.523-6.261v-1.392c0-3.46-2.917-6.26-6.523-6.26m.725 7.234c0 1.305-1.105 2.383-2.483 2.383h-4.04v-5.565h4.04c1.359 0 2.483 1.06 2.483 2.382zM131.184 6.957v12.87c0 1.53-1.305 2.782-2.9 2.782h-1.449c-1.595 0-2.899-1.253-2.899-2.783V0h-20.294l14.496 9.93v9.896c0 4.226 3.569 7.652 7.972 7.652h2.718c4.494 0 8.154-3.513 8.154-7.826V6.957z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h158v40H0z"
  })))));
};
export default SvgLogo;